import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/** Redux state for the License Management feature */
export interface LicenseManagementSliceState {
  cloudLicenseKey: number | null;
}

const initialState: LicenseManagementSliceState = {
  cloudLicenseKey: null,
};

const licenseManagementSlice = createSlice({
  name: 'aag/licenseManagement',
  initialState,
  reducers: {
    setCloudLicenseKey: (state, action: PayloadAction<number>) => {
      state.cloudLicenseKey = action.payload;
    },
    clearCloudLicenseKey: (state) => {
      state.cloudLicenseKey = null;
    },
  },
});

const { reducer: licenseManagementReducer, actions: sliceActions } =
  licenseManagementSlice;

export const licenseManagementActions = sliceActions;
export { licenseManagementReducer };
export default licenseManagementReducer;
